<template lang="pug">
#PageResultTetherdDevices
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Tethered Devices" :HeaderGlobalBreadcrumb="breadcrumb")

    //- banner filter
    ResultFilter

    .box
        header.flex.items-center.justify-between.box__header.no-border
            .header-meta
                h2.subheading Tethered Devices's List
            .header-cta
        .box__body.p-4
            template(v-if="load_data_status_tethered_device.status === 'loading'")
                Loading(show="true")

            template(v-else)
                .flex.flex-wrap.-mx-3(v-if="tethered_device && Object.keys(tethered_device).length > 0")
                    .block.p-3(class="w-full lg:w-2/6" v-for="data in tethered_device" :key="data.tethered_device")
                        .block
                            .block.border.p-3.rounded
                                .flex.items-center.mb-2
                                    figure.w-16.h-16.rounded.bg-gray-100.mr-3.overflow-hidden
                                        img.objcet-cover(src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQDL6TQy3sIznqksMdJuEJwG_fthjL0oBiyEPf1_mR2KUmI-zIX&usqp=CAU")
                                    .block.flex-grow
                                        span.block {{ data.tethered_device_name }}
                                        small {{ data.tethered_device_vendor }}
                                    .block
                                        button.btn-default.btn-icon(v-tooltip="data.tethered_device_tags.length > 0 ? data.tethered_device_tags.join(', ') : '---'")
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                //- ORDER BELUM SESUAI
                                .block(v-for="period in data.periods.slice(0, 1).reverse()")
                                    .font-bold.monospace {{ period.start.datetime }} - {{ period.end.datetime }}
                                    button.monospace.more-date(
                                        v-if="data.periods.length > 1"
                                        type="button"
                                        @click="handleHistoryTimestamp(data.tethered_device_name, data.periods)"
                                    ) See more periods

                //- template(v-else) Data Not Found
                NoDataAvailable(v-else)

    section.section-popup.fixed.w-full-h.full.inset-0.flex.items-start.justify-center(
        v-bind:class="{'section-popup--show' : seeMore}"
    )
        .section-popup__container
            .box
                .box__header.no-border
                    header.flex.items-center.justify-between
                        span.text-light {{tmpDevice}}
                        .header-cta
                            button.btn-icon.btn-icon-40(
                                v-on:click="seeMore = !seeMore"
                            )
                                .icon-btn
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                .box__body.p-4
                    template(v-for="period in tmpPeriods")
                        .font-bold.monospace.mb-3.pb-3.border-b {{ period.start.datetime }} - {{ period.end.datetime }}

</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import ResultFilter from './ResultFilter.vue';

export default {
    name: 'TetheredDevices',
    components: {
        Loading,
        NoDataAvailable,
        HeaderGlobal,
        ResultFilter,
    },
    props: ['resultGlobalBreadcrumb'],
    data: function() {
        return {
            seeMore: false,
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Tethered Devices',
                    url: '/result/tethered-devices',
                },
            ],
            tmpDevice: null,
            tmpPeriods: [],
        };
    },
    computed: {
        ...mapState([
            'load_data_status_tethered_device',
            'tethered_device',
        ]),
    },

    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        handleHistoryTimestamp(device, periods) {
            this.tmpDevice=device
            this.tmpPeriods=periods
            this.seeMore=true
        }
    }
    
}
</script>

<style lang="sass">
    .more-date
        text-decoration: underline
        &:hover
            color: $color-main
</style>
